import apiRequest from './handler';

const userService = {
    /**
     * Requests user data.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    getUserProfile: async (setIsAuthenticated, navigate, expanded=false) => {
        try {
            const response = apiRequest(
                `/reseller/profile?expanded=${expanded}`,
                'get',
                null,
                true,
                setIsAuthenticated,
                navigate
            )
            return response;
        } catch (error) {
            console.error('Error checking user status:', error);
            throw error;
        }
    },

    /**
     * Register User Data
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    registerUser: async (data, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/reseller/register`,
                'post',
                data,
                true,
                setIsAuthenticated,
                navigate
            )
            return response;
        } catch (error) {
            console.error('Error registering user:', error);
            throw error;
        }
    },
};

export default userService;
